var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDisplayFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "46 / Fill / Image - No Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.64056 2.15799C2.18387 2.24743 1.77397 2.55466 1.57425 2.95716C1.40546 3.29723 1.41314 3.10836 1.41314 6.92552V10.4454L1.47637 10.6429C1.63727 11.1454 2.09758 11.5608 2.60859 11.6647C2.70895 11.6851 4.26618 11.692 7.57878 11.6869L12.4028 11.6795L12.573 11.6164C12.928 11.4848 13.2301 11.2257 13.4011 10.9059C13.5952 10.5431 13.5865 10.728 13.587 6.91988C13.5873 4.53029 13.5779 3.43306 13.5561 3.32985C13.4694 2.91854 13.1365 2.48465 12.7667 2.30125C12.4022 2.12046 12.7016 2.13002 7.49314 2.13294C4.88702 2.1344 2.70336 2.14567 2.64056 2.15799ZM12.36 3.49945V5.68087C12.36 6.88305 12.3491 7.85034 12.3357 7.83564C12.3224 7.82097 11.888 7.32308 11.3704 6.72919C10.8528 6.13529 10.3817 5.60842 10.3235 5.55839C9.93265 5.22266 9.33744 5.22078 8.94952 5.55404C8.88849 5.60649 8.32585 6.25331 7.69921 6.99145L6.55985 8.33354L6.45561 8.24014C6.39826 8.18876 6.19722 7.99868 6.00882 7.81778C5.56784 7.39429 5.44444 7.33175 5.05258 7.33321C4.60417 7.33486 4.59763 7.33935 3.53258 8.37998L2.62629 9.26548V6.40998C2.62629 3.79279 2.63025 3.54789 2.67396 3.47519C2.70019 3.43158 2.74834 3.38317 2.781 3.3676C2.82016 3.34892 4.43299 3.33863 7.51675 3.33739L12.1931 3.33549L12.36 3.49945ZM4.14632 3.96781C3.91767 4.02831 3.77192 4.1125 3.59618 4.28558C3.12924 4.74541 3.118 5.45941 3.57026 5.92928C3.81982 6.18858 4.09902 6.30848 4.45314 6.30848C4.80493 6.30848 5.08663 6.18841 5.33135 5.93416C5.50918 5.74942 5.58736 5.60127 5.64137 5.34686C5.8212 4.49933 5.00009 3.74192 4.14632 3.96781Z",
    fill: "var(--secondary-4)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayFilled);
export default __webpack_public_path__ + "static/media/displayFilled.3d1d663dd2f4849c70ab54fad572e228.svg";
export { ForwardRef as ReactComponent };